import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { AuthService } from '../../../auth/services/auth.service';

@Component({
  selector: 'mpro-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  // hacky - should be handled with alert service for all alerts
  @Output() public yearSliderErrorEmitter: EventEmitter<string | undefined> =
    new EventEmitter();
  constructor(public authService: AuthService) {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {}
}
